import { Card, Spinner } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import PrivateLayout from '../../../layouts/PrivateLayout/PrivateLayout'
import client from '../../../api/client';
import CustomModal from '../../../components/Modal/CustomModal';
import FundWalletModal from '../../Payouts/Transfers/FundWalletModal/FundWalletModal';
import icon from '../../../assets/shareholdersIcon.png'
import { numberWithCommas } from '../../../utils/formatNumber';
import { useCurrency } from '../../../contexts/CurrencyContext';
import logo from '../../../assets/Ideos.png'
const Balance = () => {
    const [totals, setTotals] = useState({
        chargebacks: 0,
        refunds: 0,
        nonCompliance: 0
    })
    const { currency } = useCurrency()
    const [balances, setBalances] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [showModal, setShowModal] = useState({
        isOpen: false,
        data: null
    })
    const currencyData: { [key: string]: { symbol: string, bgColor: string } } = {
        USD: { symbol: '$', bgColor: 'bg-green-100' },
        EUR: { symbol: '€', bgColor: 'bg-blue-100' },
        GBP: { symbol: '£', bgColor: 'bg-purple-100' },
        NGN: { symbol: '₦', bgColor: 'bg-yellow-100' },
        KES: { symbol: 'KSh', bgColor: 'bg-yellow-100' },
        CAD: { symbol: 'C$', bgColor: 'bg-yellow-100' },
        GHS: { symbol: '₵', bgColor: 'bg-yellow-100' },

    };

    useEffect(() => {

        const fetchData = async () => {
            setLoading(true)
            await fetchTotals()
            await fetchBalances()
            setLoading(false)
        };



        fetchData();
    }, []);

    const fetchTotals = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/get/wallet/balance/totals');

            setTotals(response.data.data);
            const message = response?.data?.message;
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    }

    const fetchBalances = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/get/wallet/balance');
            console.log(response);

            setBalances(response.data.wallets);
            const message = response?.data?.message;
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    }


    return (
        <PrivateLayout>
            <div className='my-6 mx-6'>
                <div className='flex items-center gap-4 mb-4'>
                    <p className='text-xl font-semibold'>Balances</p>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-3 gap-4 h-full'>
                    <div>
                        <Card className='h-full'>
                            <p className='font-light'>Dispute/Chargebarks</p>
                            <p className='flex gap-2'>
                                <span className='font-light'>{currency}</span>
                                <span className='font-semibold text-lg'>{totals.chargebacks}</span>
                            </p>
                            <p className='text-sm underline text-green-600'>
                                View all chargebacks
                            </p>
                        </Card>
                    </div>
                    <div>
                        <Card className='h-full'>
                            <p className='font-light'>Refunds</p>
                            <p className='flex gap-2'>
                                <span className='font-light'>{currency}</span>
                                <span className='font-semibold text-lg'>{totals.refunds}</span>
                            </p>
                            <p className='text-sm underline text-green-600'>
                                View all chargebacks
                            </p>
                        </Card>
                    </div>
                    <div>
                        <Card className='h-full'>
                            <p className='font-light'>Non-compliance assessment</p>
                            <p className='flex gap-2'>
                                <span className='font-light'>{currency}</span>
                                <span className='font-semibold text-lg'>{totals.nonCompliance}</span>
                            </p>
                            <p className='text-sm text-green-600'>
                                * This is how much you’ve been charged for defaulting on compliance rules.
                            </p>
                        </Card>
                    </div>
                </div>
                <div className='my-4'>
                    <p className='text-xl font-bold text-black'>⚖️ Balances</p>
                    <p className='text-sm'>View all balances in various currencies</p>
                </div>
                <div>
                    {loading ? <div className='flex justify-center items-center'>
                        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/80">
                            <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                        </div>                    </div> :
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
                            {balances.sort((a: any, b: any) => b.availableBalance - a.availableBalance).map(balance => (
                                <div>
                                    <Card>
                                        <div className='flex items-center'>
                                            <p className='font-semibold'>{balance?.accountDetails?.bankName ?? "Not Available"}</p>
                                            <div className='flex items-center ml-auto gap-2'>
                                                <p>{balance.currencyShortName}</p>
                                                <div className={`h-12 w-12 rounded-full flex items-center justify-center font-bold text-lg gap-2 ${currencyData[balance.currencyShortName]?.bgColor}`}>
                                                    {currencyData[balance.currencyShortName]?.symbol ?? balance.currencyShortName}
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <p>Available Balance</p>
                                            <p className='font-bold text-lg'>{numberWithCommas(balance.availableBalance)}</p>
                                        </div>
                                        <div className='flex'>
                                            <div>
                                                <p>Ledger Balance</p>
                                                <p className='font-bold text-lg'>{numberWithCommas(balance.ledgerBalance)}</p>
                                            </div>
                                            {balance.currencyShortName == "NGN" && (
                                                <div className='flex items-center ml-auto' onClick={() => setShowModal({ isOpen: true, data: balance })}>
                                                    <button className='border px-6 py-1 bg-green-100'>Top up account</button>
                                                </div>
                                            )}

                                        </div>
                                    </Card>

                                </div>))}
                        </div>
                    }
                </div>


            </div>
            <CustomModal icon={icon} size='md' dismissible children={<FundWalletModal title="Fund Balance" data={showModal.data} />} show={showModal.isOpen} onClose={() => { setShowModal({ isOpen: false, data: null }) }} />
        </PrivateLayout>
    )
}

export default Balance
